import { Eye, EyeSlash } from "@phosphor-icons/react";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserDetailProvider } from "../context/CreateUserDataContext";

export default function LoginForm() {
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { setUserDetails } = useContext(UserDetailProvider);

  const navigate = useNavigate();

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    emailOrUsername: emailOrUsername,
    password: password,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);

    fetch("https://bridge-server1.onrender.com/api/login", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.message) {
          setShowError(true);
          setLoading(false);
          return setTimeout(() => {
            setShowError(false);
          }, 5000);
        }
        localStorage.setItem("token", result.token);
        localStorage.setItem("id", result.user._id);
        // Set the token from the result
        setLoading(false);
        localStorage.setItem("userDetails", JSON.stringify(result.user));
        setUserDetails(result.user);
        navigate("/dashboard");
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  return (
    <div>
      <p className="font-bold text-3xl text-white">Login</p> <br />
      <form onSubmit={submit} className="flex flex-col gap-3">
        <span className="flex flex-col gap-4">
          <label htmlFor="username" className="text-white">
            Email or PhoneNumber
          </label>
          <input
            type="text"
            name="username"
            placeholder="Email or PhoneNumber"
            id="username"
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
            value={emailOrUsername}
            onChange={(e) => setEmailOrUsername(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-4">
          <label htmlFor="password" className="text-white">
            Password
          </label>
          <span className="relative">
            {showPassword ? (
              <Eye
                size={32}
                className="cursor-pointer absolute top-2 right-5"
                color="black"
                onClick={() => setShowPassword((curr) => !curr)}
              />
            ) : (
              <EyeSlash
                size={32}
                className="cursor-pointer absolute top-2 right-5"
                color="black"
                onClick={() => setShowPassword((curr) => !curr)}
              />
            )}
            <input
              type={!showPassword ? "password" : "text"}
              name="password"
              placeholder="password"
              id="password"
              className="lg:w-[534px] lg:h-[56px] rounded-[12px] w-full p-4 px-6"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </span>
        </span>
        <button
          type="submit"
          disabled={loading}
          className={`mt-9 p-6 px-32 m-auto w-fit rounded-full ${
            loading ? "bg-gray-400" : "bg-[#01FF00]"
          } text-black font-bold text-xl`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
        <p className={showError ? "text-red-400 text-center" : "hidden"}>
          Password or Username not correct
        </p>
        <div className="flex justify-between w-full mt-9 text-white">
          <Link to="/auth/forgot-password" className="hover:underline">
            Forgot Password
          </Link>
          <Link
            //  to="/auth/signup"
            className="hover:underline"
          >
            Sign Up
          </Link>
        </div>
      </form>
    </div>
  );
}
